export default {
  required: (value) => value ? undefined : 'Vyžadovaná položka.',

  isNumber: (value) =>
    value && isNaN(Number(value)) ? 'Hodnota musí být číslo.' : undefined,

  matchesField: (matchWith) => (value, allValues) =>
    value === allValues[matchWith] ? undefined : 'Hodnota není shodná.'
};
